import gql from 'graphql-tag';
// Toaster
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from './loader/loader';

import {
  UPDATE_VERIFICATION_START,
  UPDATE_VERIFICATION_SUCCESS,
  UPDATE_VERIFICATION_ERROR,
  EMAIL_VERIFICATION_START,
  EMAIL_VERIFICATION_SUCCESS,
  EMAIL_VERIFICATION_ERROR,
  RESEND_EMAIL_VERIFICATION_START,
  RESEND_EMAIL_VERIFICATION_SUCCESS,
  RESEND_EMAIL_VERIFICATION_ERROR,
  REFRESH_VERIFICATION_START,
  REFRESH_VERIFICATION_SUCCESS,
  REFRESH_VERIFICATION_ERROR,
} from '../constants';

// Load account data to update email verification
import { loadAccount } from './account';
// Send Email
import { sendEmail } from '../core/email/sendEmail';

// To Refresh the verification status
const query = gql`
  query($userId: String!) {
    getUserVerifiedInfo(userId: $userId) {
      isEmailConfirmed
      isFacebookConnected
      isGoogleConnected
      isIdVerification
      isOnboarded
      appInstalled
      status
    }
  }
`;

export function updateVerification(item, userId) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: UPDATE_VERIFICATION_START });

    let mutation = gql`
      mutation updateUserVerifiedInfo($item: String!) {
        updateUserVerifiedInfo(item: $item) {
          status
        }
      }
    `;

    try {
      let uId = userId ? userId : getState().account.data.userId;
      const res = await client.mutate({
        mutation,
        variables: {
          item,
        },
        refetchQueries: [{ query, variables: { userId: uId } }],
      });

      const data = res.data;

      if (data.updateUserVerifiedInfo.id) {
        dispatch({ type: UPDATE_VERIFICATION_SUCCESS });
        dispatch({
          type: REFRESH_VERIFICATION_SUCCESS,
          payload: data.updateUserVerifiedInfo,
        });
      } else {
        dispatch({
          type: UPDATE_VERIFICATION_ERROR,
          payload: {
            status: data.updateUserVerifiedInfo.status,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_VERIFICATION_ERROR,
        payload: {
          error,
        },
      });
    }
  };
}

export function emailVerification(token, email, userId) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: EMAIL_VERIFICATION_START });

    let emailQuery = gql`
      query EmailVerification($token: String!, $email: String!) {
        EmailVerification(token: $token, email: $email) {
          userId
          status
        }
      }
    `;

    try {
      const { data } = await client.query({
        query: emailQuery,
        variables: {
          token,
          email: email.replace(' ', '+'),
        },
      });

      if (data.EmailVerification.status === 'confirmed') {
        dispatch({ type: EMAIL_VERIFICATION_SUCCESS });
        //If no userId then user was not logged in when
        if (userId) {
          dispatch(updateVerification('email', userId));
          dispatch(loadAccount());
        }
      }
    } catch (error) {
      dispatch({
        type: EMAIL_VERIFICATION_ERROR,
        payload: {
          error,
        },
      });
    }
  };
}

export function resendEmailVerification() {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: RESEND_EMAIL_VERIFICATION_START });
    dispatch(setLoaderStart('resendEmailLoading'));

    let resendQuery = gql`
      query ResendConfirmEmail {
        ResendConfirmEmail {
          status
        }
      }
    `;

    try {
      const { data } = await client.query({
        query: resendQuery,
      });

      if (data.ResendConfirmEmail.status !== 'error') {
        if (data.ResendConfirmEmail.status === 'success') {
          toastr.success(
            'Email is sent',
            'Confirmation link is sent to your email.',
          );
        } else {
          toastr.error(
            'Failed to send email',
            'Sorry, something went wrong. Please try again!',
          );
        }

        dispatch({ type: RESEND_EMAIL_VERIFICATION_SUCCESS });
        dispatch(setLoaderComplete('resendEmailLoading'));
      }
    } catch (error) {
      dispatch({
        type: RESEND_EMAIL_VERIFICATION_ERROR,
        payload: {
          error,
        },
      });
      dispatch(setLoaderComplete('resendEmailLoading'));
    }
  };
}

export function refreshUserVerification() {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: REFRESH_VERIFICATION_START });

    let refreshQuery = gql`
      query refreshUserVerifiedInfo($userId: String!) {
        getUserVerifiedInfo(userId: $userId) {
          userId
          profileId
          isOnboarded
          isEmailConfirmed
          isPhoneVerified
          isGoogleConnected
          isFacebookConnected
          isIdVerification
          appInstalled
        }
      }
    `;

    const userId = getState().account.data.userId;
    try {
      const { data } = await client.query({
        query: refreshQuery,
        fetchPolicy: 'network-only',
        variables: {
          userId,
        },
      });

      if (data.getUserVerifiedInfo.profileId) {
        dispatch({
          type: REFRESH_VERIFICATION_SUCCESS,
          payload: data.getUserVerifiedInfo,
        });
        return true;
      } else {
        dispatch({
          type: REFRESH_VERIFICATION_ERROR,
          payload: {
            status: data,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: REFRESH_VERIFICATION_ERROR,
        payload: {
          error,
        },
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/manageUserVerification.js